import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RomaneioService } from '../service/romaneio.service';
import { PoStorageService } from '@po-ui/ng-storage';
import { ExcelService } from 'src/app/service/excel-service';
import { FiltroRelatorioMI } from '../filter/filtro-relatorio-mi';
import { PoBreadcrumb, PoDynamicFormField, PoLookupColumn, PoSearchFilterMode, PoTableColumn } from '@po-ui/ng-components';
import { GrupoCliente } from 'src/app/interface/grupo-cliente';
import { GrupoClienteLookupService } from 'src/app/service/grupo-cliente-lookup-service';

@Component({
  selector: 'app-relatorio-mi',
  templateUrl: './relatorio-mi.component.html',
  styleUrls: ['./relatorio-mi.component.css']
})
export class RelatorioMiComponent implements OnInit {

  tabelaPrincipalItens: Array<any> = [];
  tabelaPrincipalFiltro: FiltroRelatorioMI;

  advancedGrupoClienteFilters: Array<PoDynamicFormField>;
  columnsGrupoClienteFilters: Array<PoLookupColumn>;
  fieldFormaterGrupoClienteFilters: ((value: GrupoCliente) => string);

  poSearchFilterMode: PoSearchFilterMode = PoSearchFilterMode.contains;

  constructor(
    private router: Router,
    private romaneioService: RomaneioService,
    private poStorageService: PoStorageService,
    private excelService: ExcelService,
    public grupoClienteLookupService: GrupoClienteLookupService,
  ) {
    this.tabelaPrincipalFiltro = new FiltroRelatorioMI(this.poStorageService);

    this.advancedGrupoClienteFilters = this.grupoClienteLookupService.getAdvancedFilter();
    this.columnsGrupoClienteFilters = this.grupoClienteLookupService.getColumnsFilter();
    this.fieldFormaterGrupoClienteFilters = this.grupoClienteLookupService.getFieldFormater;

  }

  ngOnInit(): void {
    this.loadLista();
  }

  loadLista(): void {
    this.tabelaPrincipalFiltro.setStorage();

    this.romaneioService.listaRelatorioMI(this.tabelaPrincipalFiltro.dados).subscribe((lista) => {
      this.tabelaPrincipalItens = lista.items;
    });
  }

  public readonly tabelaPrincipalColunas: Array<PoTableColumn> = [
    {property: 'CZ02PEDIDO', label: 'Pedido'      , width: '7%'},
    {property: 'CZ02LOTE'  , label: 'Lote'        , width: '7%'},
    {property: 'CB1COD'    , label: 'Produto'     , width: '11%'},
    {property: 'CB1DESC'   , label: 'Descrição'   , width: '25%'},
    {property: 'CZ00COD'   , label: 'Romaneio'    , width: '6%'},
    {property: 'CZ00DESTIN', label: 'Destino'     , width: '6%'},
    {property: 'CZ02PEDDES', label: 'Pedido Dest.', width: '6%'},
    {property: 'CZ01QUANT' , label: 'Qtd PC'      , width: '7%' , type: 'number'  , format: '1.2-2'},
    {property: 'CB8QTDORI2', label: 'Qtd M3'      , width: '7%' , type: 'number'  , format: '1.2-2'},
    {property: 'CC6PRCVEN' , label: 'Valor M³'    , width: '8%' , type: 'currency', format: 'BRL'},
    {property: 'CC6UNSVLR' , label: 'Valor PC'    , width: '8%' , type: 'currency', format: 'BRL'},
  ];

  public readonly breadcrumb: PoBreadcrumb = {
    items: [
      { label: 'Home', action: this.goHome.bind(this) },
      { label: 'Relatório MI' }
    ]
  };

  goHome(): void {
    this.router.navigateByUrl('');
  }

  gerarExcel(): void {
    const lista_excel = this.tabelaPrincipalItens.map( (item) => {
      return{
        'Pedido': item.CZ02PEDIDO,
        'Lote': item.CZ02LOTE,
        'Produto': item.CB1COD,
        'Descrição': item.CB1DESC,
        'Romaneio': item.CZ00COD,
        'Destino': item.CZ00DESTIN,
        'Pedido Dest.': item.CZ02PEDDES,
        'Qtd PC': item.CZ01QUANT,
        'Qtd M3': item.CB8QTDORI2,
        'Valor M³': item.CC6PRCVEN,
        'Valor PC': item.CC6UNSVLR
      }
    });

    this.excelService.exportAsExcelFile(lista_excel, `Relatório MI`);
  }

}
